/** Kurzer, eigener Benachrichtigungston per WebAudio (keine Audiodateien nötig). */
let ctx: AudioContext | null = null;
let last = 0;

export function playNotificationSound(): void {
  const now = Date.now();
  if (now - last < 800) return;
  last = now;
  try {
    const AC = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!AC) return;
    ctx ??= new AC();
    const t = ctx.currentTime;
    // Zwei warme Töne – „Funkenflug".
    for (const [i, freq] of [660, 880].entries()) {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, t + i * 0.09);
      gain.gain.exponentialRampToValueAtTime(0.12, t + i * 0.09 + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + i * 0.09 + 0.25);
      osc.connect(gain).connect(ctx.destination);
      osc.start(t + i * 0.09);
      osc.stop(t + i * 0.09 + 0.3);
    }
  } catch {
    // Autoplay-Sperre o. ä. – stumm bleiben.
  }
}
